import Vue from 'vue'
import App from './App.vue'
import store from "./store";
import router from "./router";
import i18n from "./plugins/i18n";
import "./plugins";
import "./ui_components";
import './assets/scss/main.scss'
Vue.config.productionTip = false

import { sync } from 'vuex-router-sync';
sync(store, router);
// import './firebase/config'
import "./utils/filters";

import VueMeta from 'vue-meta'

Vue.use(VueMeta)

new Vue({
  i18n,
  store,
  router,
  ...App
}).$mount('#app')
